import {
  IProfessionHobby,
  IProfessionSkill,
  IProfessionSubject,
  ITutorEducationDetails,
  ITutorExperienceDetails,
  ITutorPersonalDetails,
  ITutorProfessionDetails,
  ITutorStatus
} from '@wot/typings';
import xhr from '../utils/fetch';
import { PUpdateTutorAgreement } from './tutor-requests';

export type PUdateProfile = {
  personal?: ITutorPersonalDetails;
  education?: ITutorEducationDetails;
  experience?: ITutorExperienceDetails;
  profession?: ITutorProfessionDetails<IProfessionSubject | IProfessionHobby | IProfessionSkill>;
  status?: ITutorStatus;
  prefrences?: {
    lessonUpdates: boolean;
    accountUpdates: boolean;
    currency: string;
    timezone: string;
  };
};
const get = async (
  currentPage: number,
  resultsPerPage: number,
  filters: any,
  sortBy: any
) => {
  return await xhr({
    url: `/a/tutors`,
    params: {
      resultsPerPage: resultsPerPage.toString(),
      page: currentPage.toString(),
      ...filters,
      ...sortBy,
    },
    method: "GET"
  }).then(res => res.data)
    .catch(err => { throw err })
};

const getTutorById = async (_id: string) => {
  return await xhr({
    url: `/tutors/${_id}`,
    method: "GET"
  }).then(res => res.data)
    .catch(err => { throw err })
};

const updateAgreement = async (data: PUpdateTutorAgreement) => {
  return await xhr({
    url: `/t/update-agreement`,
    method: "PUT",
    body: data
  }).then(res => res.data)
    .catch(err => { throw err })
};

const updateProfile = async (id: string, data: PUdateProfile) => {
  return await xhr({
    url: `/t/profile`,
    method: "PUT",
    body: {
      _id: id,
      data
    }
  }).then(res => res.data)
    .catch(err => { throw err })
};

const tutorsApi = {
  get,
  getTutorById,
  updateAgreement,
  updateProfile
};

export default tutorsApi;
